import Linkify from 'react-linkify';
import appConstants from '../../../../../appConstants';
import MessageMetaData from './MessageMetaData';
import ChoiceRenderer from '../Header/MCQMessages/ChoiceRenderer';

const TextMessage = (props) => {
  const { classes, isMessageHistoryFlow } = props;
  const onReplyMsgSelected = () => {
    props.onReplyMsgSelected(props.msg);
  };
  return (
    <>
      {props.msg.messageType === appConstants.MESSAGE_TYPE.Dispatcher ? (
        /* Display independent message sent to driver app */
        <div
          className={`${classes.scMessageText} ${classes.scMessageContentSentScMessagText} ${
            isMessageHistoryFlow ? classes.scMessageHistoryText : ''
          }`}>
          <div
            className={`${classes.scMessageContentSentReply} ${
              props.msg.isUrgent ? classes.urgentMessage : ''
            }`.trim()}>
            {isMessageHistoryFlow && <span className={classes.driverDispatcherName}>{props.dispatcherName}</span>}
            <Linkify properties={{ target: '_blank' }}>
              {props.msg.message}
              {props.msg.choice?.length > 0 && ( //required when sending message to driver with options
                <ChoiceRenderer choiceData={props.msg.choice} />
              )}
            </Linkify>
            <div className={classes.timeStyle}>
              {props.convertTime(props.msg.messageDateTs)}{' '}
              {props.renderReadIcon(props.msg.isRead, classes)}
            </div>
          </div>
          {isMessageHistoryFlow ? null : (
            <div className={classes.waitingResponseStyle}>
              <div>Waiting for response</div>
            </div>
          )}
        </div>
      ) : (
        /* Display independent message received from driver app */
        <div
          className={`${classes.scMessageText} ${classes.scMessageContentReceivedScMessageText} ${
            isMessageHistoryFlow ? classes.scMessageHistoryText : ''
          }`}>
          <div className={classes.scMessageContentReceivedReply}>
            {isMessageHistoryFlow && <span className={classes.driverDispatcherName}>{props.driverName}</span>}
            {props.msg.metadata && (
              <MessageMetaData metadata={props.msg.metadata} />
            )}
            <Linkify properties={{ target: '_blank' }}>{props.msg.message}</Linkify>
            <div className={classes.timeStyle}>{props.convertTime(props.msg.messageDateTs)}</div>
          </div>
          {isMessageHistoryFlow ? null : (
            <div className={classes.sendResponse}>
              <div onClick={onReplyMsgSelected}>Send response</div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default TextMessage;
